import * as sentry from '@sentry/browser';
import apolloClient from 'services/apollo-client';
import useAddNodeToSurfaceInCache from 'components/canvas/hooks/use-add-node-to-surface-in-cache';
import { set } from 'lodash/fp';
import {
  omit,
  has,
  isPlainObject,
  transform,
  isArray,
  isEqual,
  isObject,
} from 'lodash';
import { SurfaceNodeUnion } from 'graphql/types';
import useFetchNodeFromCacheById from 'components/canvas/hooks/use-fetch-node-from-cache-by-id';

export function useSaveNodeInCache() {
  const addNodeToSurfaceInCache = useAddNodeToSurfaceInCache();
  const fetchNodeFromCacheById = useFetchNodeFromCacheById();

  return function saveNodeInCache(
    node: SurfaceNodeUnion,
    cache = apolloClient,
  ) {
    node = set('updatedAt', new Date().toISOString(), node);

    try {
      if (existsInCache(node)) {
        updateCacheObject(node);
      } else {
        addNodeToSurfaceInCache(node);
      }
    } catch (error) {
      console.log(
        '-------------- ERROR SAVE NODE IN CACHE FOR ' +
          node?.name +
          ' --------------',
      );
      console.error(error);
      sentry.captureException(error);
    }
  };

  function updateCacheObject(object) {
    apolloClient.cache.modify({
      id: apolloClient.cache.identify(object),
      fields: Object.entries(
        omit(object, ['__typename', 'originalNode']),
      ).reduce((fields, [key, value]) => {
        return {
          ...fields,
          [key]: (currentValue: any, utils) => {
            if (['originalNode'].includes(key)) {
              return currentValue;
            }

            if (isPlainObject(value) && utils.isReference(currentValue)) {
              updateCacheObject(value);
              return currentValue;
            }

            return value;
          },
        };
      }, {}),
    });
  }

  function existsInCache(node: SurfaceNodeUnion): boolean {
    return Boolean(fetchNodeFromCacheById(node.id));
    /*return has(
      apolloClient.cache,
      'data.data.' + apolloClient.cache.identify(node),
    );*/
  }
}

/**
 * Find difference between two objects
 * @param  {object} origObj - Source object to compare newObj against
 * @param  {object} newObj  - New object with potential changes
 * @return {object} differences
 */

function difference(origObject: any, newObject: any) {
  function changes(newObject: any, origObject_: any) {
    let arrayIndexCounter = 0;
    return transform(newObject, function (result: any, value, key) {
      if (!isEqual(value, origObject_[key])) {
        let resultKey = isArray(origObject_) ? arrayIndexCounter++ : key;
        result[resultKey] =
          isObject(value) && isObject(origObject_[key])
            ? changes(value, origObject_[key])
            : value;
      }
    });
  }
  return changes(newObject, origObject);
}

export default useSaveNodeInCache;
